import { useI18n } from "@/i18n/I18nContext";
import { motion } from "framer-motion";

export default function LegalPage({ i18nKey, testId }) {
  const { t } = useI18n();
  const sections = t(`${i18nKey}.sections`);
  return (
    <main className="pt-32 pb-24 md:pt-40 md:pb-32" data-testid={testId}>
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="eyebrow">{t(`${i18nKey}.updated`)}</div>
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              className="mt-4 font-serif-display text-5xl md:text-6xl leading-[1.02] tracking-tight"
            >
              {t(`${i18nKey}.title`)}
            </motion.h1>
          </div>
          <div className="lg:col-span-7 lg:col-start-6 space-y-10">
            {Array.isArray(sections) &&
              sections.map((s, i) => (
                <motion.section
                  key={i}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.6, delay: i * 0.04 }}
                  className="border-t border-slate-900/12 pt-8"
                >
                  <h2 className="font-serif-display text-2xl md:text-3xl text-[#0F172A]">
                    {s.heading}
                  </h2>
                  <p className="mt-3 text-[#525866] leading-relaxed">{s.body}</p>
                </motion.section>
              ))}
          </div>
        </div>
      </div>
    </main>
  );
}
